/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-05.
 * Action constants types.
 */
const PREFIX = 'playground';
export const NOTIFY = `${PREFIX}_notify`;



// WEBPACK FOOTER //
// ./containers/playground/types.js